import { useSearchParams } from 'react-router';
import { SearchCore } from '../components/search/SearchCore';

export function SearchPage() {
  const [searchParams] = useSearchParams();
  const initialQuery = searchParams.get('q') || '';

  return (
    <div className="mx-auto max-w-2xl py-4">
      <SearchCore mode="inline" initialValue={initialQuery} />
    </div>
  );
}
